'use strict';

angular.module('internal.investigations', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // internal routings
            // investigations tab
            .state('internal.licensing.investigations', {
                url: '/investigations',
                templateUrl: paths.app + 'investigations/components/investigations/investigations.html',
                controller: 'InternalInvestigations',
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internalNH.investigations', {
                url: '/investigationsNH/:previewID',
                templateUrl: paths.app + 'investigations/components/investigations/investigations.html',
                controller: 'InternalInvestigations',
                params: {
                    previewID: {
                        value: null,
                        squash: true
                    }
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        //Used for the investigation internal view preview
                        return Permissions.view("internal.setup.enterprise.security.internalViews").then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.investigation', {
                abstract: true,
                templateUrl: paths.app + 'investigations/components/investigation/investigation.html',
                controller: 'InternalInvestigation',
                params: {
                    id: null,
                    investigation: null,
                    user: null,
                    service: null,
                    vehicle: null
                }
            })
                .state('internal.licensing.investigation.details', {
                    url: '/investigation/:id?userId&vehicleId&serviceId',
                    templateUrl: paths.app + 'investigations/components/investigation-react/investigation-react.html',
                    controller: 'InternalInvestigationReact',
                    params: {
                        id: null,
                        investigation: null,
                        userId: null,
                        vehicleId: null,
                        serviceId: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.id == null) {
                                method = 'add';
                            }

                            return Permissions[method](this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.investigation.activitytracking', {
                    url: '/investigation/:id/activitytracking',
                    templateUrl: paths.app + 'investigations/components/investigation-activity-tracking/investigation-activity-tracking.html',
                    controller: 'InternalInvestigationActivityTracking',
                    params: {
                        id: null,
                        investigation: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
            .state('internal.licensing.investigation.activitytrackingedit', {
                url: '/investigation/:id/activity/:investigationActivityTrackingID',
                templateUrl: paths.app + 'investigations/components/investigation-activity-tracking-edit/investigation-activity-tracking-edit.html',
                controller: 'InternalInvestigationActivityTrackingEdit',
                params: {
                    id: null,
                    investigation: null,
                    investigationActivityTrackingID: null,
                    investigation_activity: null
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;

                        var method = 'view';
                        if ($stateParams.investigationActivityTrackingID == null) {
                            method = 'add';
                        }

                        return Permissions[method]('internal.licensing.investigation.activitytracking').then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.investigation.activitytrackinghistory', {
                url: '/investigation/:id/activity/:investigationActivityTrackingID/:investigationActivityTrackingHistoryID',
                templateUrl: paths.app + 'investigations/components/investigation-activity-tracking-edit/investigation-activity-tracking-edit.html',
                controller: 'InternalInvestigationActivityTrackingEdit',
                params: {
                    id: null,
                    investigation: null,
                    investigationActivityTrackingID: null,
                    investigationActivityTrackingHistoryID: null,
                    investigation_activity: null
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view('internal.licensing.investigation.activitytracking').then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
                .state('internal.licensing.investigation.monitoring', {
                    url: '/investigation/:id/monitoring',
                    templateUrl: paths.app + 'investigations/components/investigation-monitoring/investigation-monitoring.html',
                    controller: 'InternalInvestigationMonitoring',
                    params: {
                        id: null,
                        investigation: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.investigation.history', {
                    url: '/investigation/:id/history',
                    templateUrl: paths.app + 'investigations/components/investigation-history/investigation-history.html',
                    controller: 'InternalInvestigationHistory',
                    params: {
                        id: null,
                        investigation: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.investigation.alerts', {
                    url: '/investigation/:id/alerts',
                    templateUrl: paths.app + 'investigations/components/investigation-alerts/investigation-alerts.html',
                    controller: 'InternalInvestigationAlerts',
                    params: {
                        id: null,
                        investigation: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.investigation.alert', {
                    url: '/investigation/:id/alert/:investigationAlertID',
                    templateUrl: paths.app + 'investigations/components/investigation-alert/investigation-alert.html',
                    controller: 'InternalInvestigationAlert',
                    params: {
                        id: null,
                        investigation: null,
                        investigationAlertID: null,
                        investigation_alert: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.investigationAlertID == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.licensing.investigation.alerts').then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.investigation.correspondences', {
                    url: '/investigation/:id/correspondences',
                    templateUrl: paths.app + 'investigations/components/investigation-correspondences/investigation-correspondences.html',
                    controller: 'InternalInvestigationCorrespondences',
                    params: {
                        id: null,
                        investigation: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.investigation.correspondence', {
                    url: '/investigation/:id/correspondence/:investigationCorrespondenceID',
                    templateUrl: paths.app + 'investigations/components/investigation-correspondence/investigation-correspondence.html',
                    controller: 'InternalInvestigationCorrespondence',
                    params: {
                        id: null,
                        investigation: null,
                        investigationCorrespondenceID: null,
                        investigation_correspondence: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.investigationCorrespondenceID == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.licensing.investigation.correspondences').then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.investigation.documents', {
                    url: '/investigation/:id/documents',
                    templateUrl: paths.app + 'investigations/components/investigation-documents/investigation-documents.html',
                    controller: 'InternalInvestigationDocuments',
                    params: {
                        id: null,
                        investigation: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.investigation.document', {
                    url: '/investigation/:id/document/:investigationDocumentID',
                    templateUrl: paths.app + 'investigations/components/investigation-document/investigation-document.html',
                    controller: 'InternalInvestigationDocument',
                    params: {
                        id: null,
                        investigation: null,
                        investigationDocumentID: null,
                        investigation_document: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.investigationDocumentID == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.licensing.investigation.documents').then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.investigation.notes', {
                    url: '/investigation/:id/notes',
                    templateUrl: paths.app + 'investigations/components/investigation-notes/investigation-notes.html',
                    controller: 'InternalInvestigationNotes',
                    params: {
                        id: null,
                        investigation: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.investigation.note', {
                    url: '/investigation/:id/note/:investigationNoteID',
                    templateUrl: paths.app + 'investigations/components/investigation-note/investigation-note.html',
                    controller: 'InternalInvestigationNote',
                    params: {
                        id: null,
                        investigation: null,
                        investigationNoteID: null,
                        investigation_note: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.investigationNoteID == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.licensing.investigation.notes').then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
    }])
;